import type { FILTER_OPTIONS_DIVIDER } from '@repo/common/components/Filter';

export enum AutomationEditType {
	// Owners
	OWNERS_ADD = 'owners_add',
	OWNERS_REMOVE = 'owners_remove',
	OWNERS_REPLACE = 'owners_replace',
	OWNERS_CLEAR = 'owners_clear',

	// Subscribers
	SUBSCRIBERS_ADD = 'subscribers_add',
	SUBSCRIBERS_REMOVE = 'subscribers_remove',
	SUBSCRIBERS_REPLACE = 'subscribers_replace',
	SUBSCRIBERS_CLEAR = 'subscribers_clear',

	// Tags
	TAGS_ADD = 'tags_add',
	TAGS_REMOVE = 'tags_remove',
	TAGS_REPLACE = 'tags_replace',
	TAGS_CLEAR = 'tags_clear',

	// Description
	DEFINITION_SET = 'definition_set',
	DEFINITION_CLEAR = 'definition_clear',

	// Description
	DESCRIPTION_SET = 'description_set',
	DESCRIPTION_CLEAR = 'description_clear',

	// Governance - PII
	PII_TRUE = 'pii_true',
	PII_FALSE = 'pii_false',

	// Governance - Verified
	VERIFIED_TRUE = 'verified_true',
	VERIFIED_FALSE = 'verified_false',

	// Status = Published
	PUBLISHED_TRUE = 'published_true',
	PUBLISHED_FALSE = 'published_false',

	// Teams
	TEAMS_ADD = 'teams_add',
	TEAMS_REMOVE = 'teams_remove',
	TEAMS_REPLACE = 'teams_replace',
	TEAMS_CLEAR = 'teams_clear',
	TEAMS_ADD_ALL = 'teams_add_all',

	// Collections
	COLLECTIONS_ADD = 'collections_add',
	COLLECTIONS_REMOVE = 'collections_remove',
	COLLECTIONS_REPLACE = 'collections_replace',
	COLLECTIONS_CLEAR = 'collections_clear',
}

export interface AutomationEdit {
	key: string;
	type: AutomationEditType;
	value: string | boolean | string[];
	display: string | null;
	isAiEditAction?: boolean | null;
}

export interface AutomationEditValue {
	editType: AutomationEditType;
	value: string | null;
}

export interface EditItem {
	value: string | boolean | string[];
	label: string;
	icon?: React.ReactNode;
}

export interface EditItemFunction {
	getItems:
		| (EditItem | typeof FILTER_OPTIONS_DIVIDER)[]
		| ((
				page?: number,
				searchTerm?: string
		  ) =>
				| (EditItem | typeof FILTER_OPTIONS_DIVIDER)[]
				| Promise<(EditItem | typeof FILTER_OPTIONS_DIVIDER)[]>);
	getItemsById?: (ids: string[]) => EditItem[] | Promise<EditItem[]>;
}

export enum AutomationEditOption {
	OWNER = 'owner',
	TAG = 'tag',
	TEAM = 'team',
	COLLECTION = 'collection',
	SUBSCRIBER = 'subscriber',
	DOCUMENTATION = 'documentation',
	DESCRIPTION = 'description',
	PII = 'pii',
	VERIFIED = 'verified',
	PUBLISHED = 'published',
}

export enum EditValueType {
	SINGLE = 'single',
	MULTIPLE = 'multiple',
}

export enum EditDropdownType {
	LIST = 'list',
	STRING = 'string',
}
